"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ancientBooksApi = exports.ancientPoetryApi = void 0;
var request_1 = __importDefault(require("@/utils/request"));
exports.ancientPoetryApi = {
    getAncientPoetryList: function (params) {
        if (params === void 0) { params = {}; }
        return (0, request_1.default)({
            url: "/ancient/poetry/",
            method: "get",
            params: params,
        });
    },
    getAncientPoetryInfo: function (id) {
        return (0, request_1.default)({
            url: "/ancient/poetry/".concat(id, "/"),
            method: "get",
        });
    },
    getFamousList: function (params) {
        if (params === void 0) { params = {}; }
        return (0, request_1.default)({
            url: "/ancient/famous/",
            method: "get",
            params: params,
        });
    },
    getFamousInfo: function (id) {
        return (0, request_1.default)({
            url: "/ancient/famous/".concat(id, "/"),
            method: "get",
        });
    }
};
exports.ancientBooksApi = {
    getAncientBooksList: function (params) {
        if (params === void 0) { params = {}; }
        return (0, request_1.default)({
            url: "/ancient/books/",
            method: "get",
            params: params,
        });
    },
    getAncientBooksInfo: function (id) {
        return (0, request_1.default)({
            url: "/ancient/books/".concat(id, "/"),
            method: "get",
        });
    },
    setCollected: function (data) {
        return (0, request_1.default)({
            url: "/user/collected-info/",
            method: "put",
            data: data
        });
    },
    postCollected: function (data) {
        return (0, request_1.default)({
            url: "/user/collected-info/",
            method: "post",
            data: data
        });
    },
};
